import React, { useEffect, useState } from "react";

const FILTERS = [
  { label: "All", value: "*" },
  { label: "Events", value: "Event" },
  { label: "Prize Distribution", value: "Prize" },
  { label: "Activity", value: "Activity" },
  { label: "Ceremony", value: "Program" },
  { label: "Other", value: "Other" },
];

const apiUrl = "/api/home/gallery-full";

export default function GalleryPage() {
  const [images, setImages] = useState([]);
  const [activeFilter, setActiveFilter] = useState("*");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modalIndex, setModalIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetch(apiUrl)
      .then((r) => {
        if (!r.ok) throw new Error("Failed to fetch gallery images");
        return r.json();
      })
      .then((data) => {
        setImages(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Unknown error");
        setLoading(false);
      });
  }, []);

  const filteredImages =
    activeFilter === "*"
      ? images
      : images.filter((img) => img.category === activeFilter);

  const openModal = (index) => setModalIndex(index);
  const closeModal = () => setModalIndex(null);

  const showPrev = () => {
    setModalIndex((prev) =>
      prev === 0 ? filteredImages.length - 1 : prev - 1
    );
  };
  const showNext = () => {
    setModalIndex((prev) =>
      prev === filteredImages.length - 1 ? 0 : prev + 1
    );
  };

  useEffect(() => {
    if (modalIndex === null) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowLeft") showPrev();
      if (e.key === "ArrowRight") showNext();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [modalIndex, filteredImages.length]);

  const modalImage =
    modalIndex !== null && filteredImages[modalIndex]
      ? filteredImages[modalIndex]
      : null;

  return (
    <section id="portfolio" style={{ minHeight: 600, paddingTop: 60 }}>
      <div className="container">
        <ul
          className="portfolio-filter text-center"
          style={{
            padding: 0,
            marginBottom: 40,
            marginTop: 90, // <--- ADDED to prevent overlap (adjust as per navbar height)
            zIndex: 2,
            position: "relative",
            background: "#fff", // optional: gives a white background to tabs if needed
          }}
        >
          {FILTERS.map((f) => (
            <li key={f.value} style={{ display: "inline-block", marginRight: 8 }}>
              <button
                className={`btn btn-default${activeFilter === f.value ? " active" : ""}`}
                style={{ fontWeight: activeFilter === f.value ? 600 : 400 }}
                onClick={() => setActiveFilter(f.value)}
              >
                {f.label}
              </button>
            </li>
          ))}
        </ul>
        {loading && <div>Loading gallery...</div>}
        {error && <div style={{ color: "red" }}>{error}</div>}
        <div className="row portfolio-items">
          {filteredImages.length === 0 && !loading ? (
            <div style={{ color: "#888", textAlign: "center", width: "100%" }}>
              No images found for this filter.
            </div>
          ) : (
            filteredImages.map((img, i) => (
              <div
                key={i}
                className="col-xs-12 col-sm-4 col-md-3 portfolio-item"
                style={{ marginBottom: 20 }}
              >
                <div
                  className="recent-work-wrap"
                  style={{ position: "relative", overflow: "hidden" }}
                >
                  <img
                    className="img img-responsive"
                    src={img.imageURL}
                    alt={img.title || "Gallery"}
                    onError={(e) =>
                      (e.target.src =
                        "https://via.placeholder.com/400x250?text=Image+Not+Found")
                    }
                    style={{ width: "100%", borderRadius: 8 }}
                  />
                  <div
                    className="overlay"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(0,0,0,0.4)",
                      color: "#fff",
                      opacity: 0,
                      transition: "opacity 0.3s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div className="recent-work-inner" style={{ textAlign: "center" }}>
                      <h3 style={{ fontWeight: 700 }}>{img.title}</h3>
                      <button
                        className="preview"
                        style={{
                          color: "#fff",
                          textDecoration: "underline",
                          fontSize: 18,
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                        onClick={() => openModal(i)}
                      >
                        <i className="fa fa-eye" style={{ marginRight: 6 }} />
                        View
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      {/* Modal */}
      {modalImage && (
        <div
          className="gallery-modal"
          onClick={closeModal}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: 12,
              padding: 24,
              boxShadow: "0 8px 40px rgba(0,0,0,0.25)",
              maxWidth: 650,
              width: "90vw",
              maxHeight: "90vh",
              overflow: "auto",
              textAlign: "center",
              position: "relative",
              animation: "fadeInScale 0.2s cubic-bezier(.4,2,.4,1)",
            }}
          >
            <button
              onClick={closeModal}
              style={{
                position: "absolute",
                top: 8,
                right: 16,
                fontSize: 28,
                color: "#333",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontWeight: 700,
                lineHeight: 1,
              }}
              aria-label="Close"
            >
              &times;
            </button>
            {/* Previous Button */}
            <button
              onClick={showPrev}
              style={{
                position: "absolute",
                top: "50%",
                left: 0,
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                color: "#444",
                fontSize: 40,
                cursor: "pointer",
                fontWeight: 700,
                zIndex: 1,
                padding: "0 12px",
                lineHeight: 1,
                userSelect: "none"
              }}
              aria-label="Previous"
            >
              &#8249;
            </button>
            {/* Next Button */}
            <button
              onClick={showNext}
              style={{
                position: "absolute",
                top: "50%",
                right: 0,
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                color: "#444",
                fontSize: 40,
                cursor: "pointer",
                fontWeight: 700,
                zIndex: 1,
                padding: "0 12px",
                lineHeight: 1,
                userSelect: "none"
              }}
              aria-label="Next"
            >
              &#8250;
            </button>
            <img
              src={modalImage.imageURL}
              alt={modalImage.title || "Gallery"}
              style={{
                width: "100%",
                maxHeight: 350,
                objectFit: "contain",
                borderRadius: 8,
                marginBottom: 16,
                background: "#f0f0f0",
              }}
              onError={(e) =>
                (e.target.src =
                  "https://via.placeholder.com/400x250?text=Image+Not+Found")
              }
            />
            <h2 style={{ fontWeight: 700, marginBottom: 10 }}>{modalImage.title}</h2>
            {modalImage.description && (
              <p style={{ color: "#444", marginBottom: 10 }}>
                {modalImage.description}
              </p>
            )}
            <div style={{ color: "#888", fontSize: 14 }}>
              Category: {modalImage.category || "Unknown"}
            </div>
            <div style={{ color: "#bbb", fontSize: 13, marginTop: 10 }}>
              {modalIndex + 1} / {filteredImages.length}
            </div>
          </div>
        </div>
      )}
      <style>
        {`
        .recent-work-wrap:hover .overlay {
          opacity: 1 !important;
        }
        @keyframes fadeInScale {
          from { opacity: 0; transform: scale(0.85);}
          to { opacity: 1; transform: scale(1);}
        }
        `}
      </style>
    </section>
  );
}
